export var featuresMap = {
  create_question_limit: {
    label: '{limit} questions'
  },
  analyze_response_limit: {
    label: '{limit} responses'
  },
  num_free_responses: {
    label: '{limit} responses'
  },
  create_logo_enabled: {
    label: 'Add your logo'
  },
  create_skip_logic_enabled: {
    label: 'Skip logic'
  },
  analyze_export_enabled: {
    label: 'Export data (CSV, PDF, PPT, XLS)'
  },
  create_randomization_enabled: {
    label: 'Randomize questions and pages'
  },
  analyze_can_ta_search: {
    label: 'View text analysis'
  },
  show_sig_diffs_enabled: {
    label: 'Measure statistical significance'
  },
  analyze_export_spss_enabled: {
    label: 'Export to SPSS'
  },
  create_toggle_footer_enabled: {
    label: 'Hide SurveyMonkey footer'
  },
  phone_support: {
    label: 'Phone support'
  },
  create_piping_enabled: {
    label: 'Pipe questions and answers'
  },
  collaboration: {
    label: 'Share surveys with collaborators'
  },
  extract_data: {
    label: 'Export results'
  },
  extended_piping: {
    label: 'Advanced branching and piping'
  },
  single_sign_on: {
    label: 'Single sign-on (SSO)'
  },
  view_respondent_ip_address: {
    label: 'See response IP addresses'
  },
  admin_dashboard: {
    label: 'Admin dashboard'
  },
  custom_charts: {
    label: 'Create custom charts'
  },
  api_access: {
    label: 'Direct API access'
  },
  collector_friendly_url_enabled: {
    label: 'Custom survey links'
  },
  funneling_enabled: {
    label: 'Carry forward responses'
  },
  custom_templates: {
    label: 'Survey templates'
  },
  create_random_assignment_enabled: {
    label: 'A/B test text and images'
  },
  matrix_question_type: {
    label: 'Matrix/Rating Scale questions'
  },
  analyze_trends_enabled: {
    label: 'See data trends over time'
  },
  enable_ip_blocking: {
    label: 'Block IP addresses'
  },
  analyze_shared_results_enabled: {
    label: 'Share your results'
  },
  record_respondent_email_address: {
    label: 'Track email responses'
  },
  shared_group_library: {
    label: 'Upload brand assets'
  },
  collector_white_label_enabled: {
    label: 'White label collectors'
  },
  menu_matrix_enabled: {
    label: 'Matrix of dropdown menus'
  },
  analyze_can_export_hide_branding: {
    label: 'White label exports'
  },
  create_print_enabled: {
    label: 'Print your survey'
  },
  analyze_password_enabled: {
    label: 'Password-protect shared results'
  },
  create_quotas_enabled: {
    label: 'Response quotas'
  },
  randomize_answer_choices: {
    label: 'Randomize answer choices'
  },
  set_survey_end_date: {
    label: 'Set survey end date'
  },
  analyze_can_ta_tag: {
    label: 'Categorize text responses'
  },
  download_as_csv_xls_pdf: {
    label: 'Export results'
  },
  download_as_ppt: {
    label: 'Export to PowerPoint'
  },
  benchmarks: {
    label: 'Compare with Benchmarks'
  },
  question_library: {
    label: 'Question Bank'
  },
  customize_disqualification_page_enabled: {
    label: 'Disqualify respondents'
  },
  analyze_response_delete_limit: {
    label: 'Delete {limit} responses'
  },
  advanced_logic: {
    label: 'Advanced branching and piping'
  },
  create_custom_html_email_message_enabled: {
    label: 'Custom HTML email invitations'
  },
  analyze_can_export_ta: {
    label: 'Categorize text responses'
  },
  real_time_results: {
    label: 'See results in real time'
  },
  collector_max_responses_delete_count: {
    label: 'Delete {limit} responses'
  },
  '508_accessibility': {
    label: 'Create 508-compliant surveys'
  },
  file_upload: {
    label: 'Let survey takers upload files'
  },
  disable_closed_page_branding_enabled: {
    label: 'Remove SurveyMonkey branding'
  },
  all_languages_supported: {
    label: 'Build multilingual surveys'
  },
  email_tracking_enabled: {
    label: 'Track email invitations'
  },
  shared_library: {
    label: 'Use assets from team Library'
  },
  create_custom_variables_enabled: {
    label: 'Custom variables'
  },
  hide_export_branding_enabled: {
    label: 'White label exports'
  },
  asset_library: {
    label: 'Use assets from team Library'
  },
  priority_email_support: {
    label: 'Priority email support'
  },
  survey_templates_intl: {
    label: 'International survey templates'
  },
  analyze_rule_limit: {
    label: '{limit} filters per survey'
  },
  create_custom_theme_enabled: {
    label: 'Premium themes'
  },
  collector_create_limit: {
    label: '{limit} collectors per survey'
  },
  analyze_delete_respondent_limit: {
    label: 'Delete {limit} respondents'
  },
  pop_up_collector: {
    label: 'Pop up collector'
  },
  mobile_sdk_pull_response_data_enabled: {
    label: 'Mobile SDK'
  },
  analyze_can_share_customize_branding: {
    label: 'Customize shared results'
  },
  track_email_responses: {
    label: 'Track email responses'
  },
  webhooks_read: {
    label: 'Webhooks'
  },
  team_themes: {
    label: 'Share company themes'
  },
  analyze_ta_enabled: {
    label: 'View text analysis'
  },
  multiple_block_rotation_enabled: {
    label: 'Block randomization'
  },
  analyze_access_benchmarking: {
    label: 'Compare with Benchmarks'
  },
  carry_forward: {
    label: 'Carry forward responses'
  },
  disable_footer_branding_enabled: {
    label: 'Hide SurveyMonkey branding'
  },
  maximum_daily_messages: {
    label: '{limit} daily message limit'
  },
  create_templates_enabled: {
    label: 'Custom templates'
  },
  multilingual: {
    label: 'Build multilingual surveys'
  },
  webhooks_write: {
    label: 'Webhooks'
  },
  collector_recipients_limit: {
    label: '{limit} recipients'
  },
  collector_thank_you_enabled: {
    label: 'Custom thank you page'
  },
  email_support: {
    label: 'Email support'
  },
  teams_enabled: {
    label: 'Collaborate with teams'
  },
  collect_email_throttle_limit: {
    label: '{limit} email limit'
  },
  multiple_users: {
    label: 'Multiple users'
  },
  statistical_significance: {
    label: 'Measure statistical significance'
  },
  validate_answer: {
    label: 'Validate answers'
  },
  add_users: {
    label: 'Add users'
  },
  ssl_tls_encryption: {
    label: 'SSL/TLS Encryption'
  },
  filter_crosstab: {
    label: 'Filter and compare responses'
  },
  collector_email_limit: {
    label: '{limit} emails'
  },
  quizzes_pro: {
    label: 'Quizzes with custom feedback'
  },
  password_protection: {
    label: 'Password-protect surveys'
  },
  collector_contact_list_limit: {
    label: '{limit} contacts'
  },
  disable_email_message_branding_enabled: {
    label: 'Hide SurveyMonkey logo in emails'
  },
  collector_completion_url_enabled: {
    label: 'Redirect respondents to another site'
  },
  a_b_testing: {
    label: 'A/B test text and images'
  },
  recurring_surveys: {
    label: 'Send recurring surveys'
  },
  user_management: {
    label: 'User management'
  },
  analyze_can_customize_charts: {
    label: 'Custom charts'
  },
  question_library_intl: {
    label: 'Question library'
  },
  rating_question_type: {
    label: 'Rating question'
  },
  collect_min_daily_messages_limit: {
    label: '{limit} daily messages'
  },
  analyze_can_save_views: {
    label: 'Save filters and views'
  },
  group_templates: {
    label: 'Group templates'
  },
  video_question_type: {
    label: 'Video question'
  },
  team_ownership: {
    label: 'Team ownership'
  },
  consolidated_billing: {
    label: 'Consolidated billing'
  },
  analyze_can_share_customize_domain: {
    label: 'Custom results domain'
  },
  data_ownership: {
    label: 'Data ownership'
  },
  max_collectors_per_survey: {
    label: '{limit} collectors per survey'
  },
  hipaa_enabled: {
    label: 'HIPAA'
  },
  group_contacts_limit: {
    label: '{limit} group contacts'
  },
  payment_qt: {
    label: 'Accept payments'
  },
  click_map_qt: {
    label: 'Click map data visualization'
  },
  create_grayscale_footer: {
    label: 'Subtle SurveyMonkey footer'
  },
  premium_themes: {
    label: 'Premium themes'
  },
  create_custom_chatbot_avatar: {
    label: 'Add your custom avatar'
  },
  comment_box_question_type: {
    label: 'Comment box question'
  },
  collect_contact_information: {
    label: 'Contact information'
  },
  ranking_question_type: {
    label: 'Ranking question'
  },
  star_rating_question_type: {
    label: 'Rating question'
  },
  slider_question_type: {
    label: 'Slider question'
  },
  textbox_multiple_question_type: {
    label: 'Multiple textboxes'
  },
  bulk_survey_share: {
    label: 'Share surveys with team'
  },
  publish_dashboard: {
    label: 'Publish dashboard'
  },
  remove_watermark: {
    label: 'Remove watermark'
  },
  share_and_export: {
    label: 'Share & export results'
  },
  best_worst_qt: {
    label: 'Best worst scale'
  }
};
export var sortedTBYBFeaturesMap = [{
  wall_random_assignment: 'create_random_assignment_enabled'
}, {
  wall_block_randomization: 'multiple_block_rotation_enabled'
}, {
  wall_funneling: 'funneling_enabled'
}, {
  wall_logo: 'create_logo_enabled'
}, {
  wall_footer: 'create_toggle_footer_enabled'
}, {
  wall_pageskiplogic: 'create_skip_logic_enabled'
}, {
  wall_page_randomization: 'create_randomization_enabled'
}, {
  wall_question_randomization: 'create_randomization_enabled'
}, {
  wall_quotas: 'create_quotas_enabled'
}, {
  wall_custom_variables: 'create_custom_variables_enabled'
}, {
  wall_themes: 'create_custom_theme_enabled'
}, {
  wall_questionskip_logic: 'create_skip_logic_enabled'
}, {
  wall_piping: 'create_piping_enabled'
}, {
  wall_question_matrix: 'matrix_question_type'
}, {
  wall_question_menu_matrix: 'menu_matrix_enabled'
}, {
  wall_maxquestions: 'create_question_limit'
}, {
  wall_question_file_upload: 'file_upload'
}, {
  wall_multilingual: 'multilingual'
}, {
  wall_quizzes_pro: 'quizzes_pro'
}, {
  wall_question_payment: 'payment_qt'
}, {
  wall_question_click_map: 'click_map_qt'
}, {
  wall_footer_grayscale: 'create_grayscale_footer'
}, {
  wall_premium_themes: 'create_custom_theme_enabled'
}, {
  wall_custom_avatar: 'create_custom_chatbot_avatar'
}, {
  wall_comment_box: 'comment_box_question_type'
}, {
  wall_contact_info: 'collect_contact_information'
}, {
  wall_multiple_textboxes: 'textbox_multiple_question_type'
}, {
  wall_ranking: 'ranking_question_type'
}, {
  wall_slider: 'slider_question_type'
}, {
  wall_star_rating_scale: 'star_rating_question_type'
}, {
  wall_share_surveys: 'bulk_survey_share'
}, {
  wall_question_best_worst: 'best_worst_qt'
}];